import { ErrorHandler, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import * as Sentry from "@sentry/angular";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FingerprintJSPro, FingerprintjsProAngularModule } from '@fingerprintjs/fingerprintjs-pro-angular';
import { CookieService } from 'ngx-cookie-service';
import { InfiniteScrollModule } from "ngx-infinite-scroll";

import { tokenInterceptor } from '@core/interceptors/token.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from '@core/core.module';

import { AppComponent } from './app.component';

import { ConfigService } from './core/services/config.service';
import { SentryService } from './core/services/sentry.service';
import { ApplicationService } from '@core/services/application.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgHttpLoaderComponent, pendingRequestsInterceptor$ } from 'ng-http-loader';
import { TrackingService } from './core/services/tracking.service';
import { GrowthbookService } from '@core/services/growthbook.service';

registerLocaleData(localeNl);

export function loadConfigFactory(configService: ConfigService, applicationService: ApplicationService, sentryService: SentryService, trackingService: TrackingService, growthbookService: GrowthbookService) {
	return () =>
		new Promise((resolve, reject) => {

			configService.load()
				.then(async () => {
					sentryService.init();
					trackingService.init();
					await growthbookService.init();
					applicationService.getApplicationData()
						.finally(() => resolve(true));
				})
		});
}

export function createTranslateLoader(http: HttpClient) {

	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
	declarations: [
		AppComponent
	],
	bootstrap: [AppComponent], imports: [BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		CoreModule,
		FontAwesomeModule,
		NgHttpLoaderComponent,
		FingerprintjsProAngularModule.forRoot({
			loadOptions: {	
				apiKey: "ONTTt9VXt8kpBKi754BD",
				endpoint: [
					"https://metrics.kwo.nl",
					FingerprintJSPro.defaultEndpoint
				],
				scriptUrlPattern: [
					"https://metrics.kwo.nl/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",
					FingerprintJSPro.defaultScriptUrlPattern
				],
				region: "eu"
			}
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (createTranslateLoader),
				deps: [HttpClient]
			}
		}),
		InfiniteScrollModule,
		NgbModule],
	providers: [
		{
			provide: LOCALE_ID,
			useValue: "nl-NL"
		},
		ConfigService,
		SentryService,
		TrackingService,
		GrowthbookService,
		provideAppInitializer(() => {
			const initializerFn = (loadConfigFactory)(inject(ConfigService), inject(ApplicationService), inject(SentryService), inject(TrackingService), inject(GrowthbookService));
			return initializerFn();
		}),
		{
			provide: 'googleTagManagerId',
			useValue: 'GTM-MWRGFQZ'
		},
		[CookieService],
		provideHttpClient(withInterceptors([pendingRequestsInterceptor$, tokenInterceptor])),
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler(),
		},
	]
})
export class AppModule { }
